<template>
  <!-- 应收对账单修改 -->
  <div class="jy-form-container">
    <!-- 按钮组 -->
    <div class="button-ground">
      <el-button type="primary" @click="onSave">保存</el-button>
      <el-button plain class="jy-button" @click="onButtonFun(1)"
      >审批</el-button
      >
      <el-button plain class="jy-button" @click="onButtonFun(2)"
      >反审批</el-button
      >
      <el-button plain class="jy-button" @click="onButtonFun(3)"
      >推送对账单</el-button
      >
      <el-button plain class="jy-button" @click="onButtonFun(4)"
      >对账确认</el-button
      >
      <el-button plain class="jy-button" @click="onButtonFun(5)"
      >取消对账</el-button
      >
      <el-button plain class="jy-button" @click="onButtonFun(6)"
      >删除</el-button
      >
<!--      <el-button plain class="jy-button" @click="onPrint">打印对账单</el-button>-->
<!--      <el-button plain class="jy-button">导出对账单</el-button>-->
    </div>
    <div class="form-line"></div>
    <div class="jy-line-container">
      <AngleDouble title="对账信息">
        <el-form
            :model="baseFormInfo"
            label-width="150px"
            label-position="right"
        >
          <el-row :gutter="gutter">
            <el-col :span="span">
              <el-form-item label="对账单号：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.statementNumber"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="结算对象：" class="jy-form-input">
                <div style="display: flex;  width: 100%">
                  <el-select
                      clearable
                      v-model="baseFormInfo.baseInfo.objectStatus"
                      :disabled="true"
                      placeholder="对象类型"
                      @visible-change="visibleChange($event, 1)"
                  >
                    <el-option
                        v-for="(item, index) in objectStatusOptions"
                        :key="index"
                        :label="item.val"
                        :value="item.confDictId"
                    />
                  </el-select>
                  <el-select
                      clearable
                      v-model="baseFormInfo.baseInfo.objectName"
                      :disabled="disabledTable"
                      placeholder="对象名称"
                      @visible-change="visibleChange($event, 2)"
                      @change="onSelectObjectName"
                      style="margin-left: 10px"
                  >
                    <el-option
                        v-for="(item, index) in objectNameOptions"
                        :key="index"
                        :label="item.userMemberName"
                        :value="item.memberId"
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="对账部门：" class="jy-form-input">
                <el-select
                    v-model="baseFormInfo.baseInfo.reconciliationDeptName"
                    placeholder="请选择"
                    clearable
                    @visible-change="visibleChange($event, 3)"
                    @change="
                    onSelect(
                      $event,
                      storageOptions,
                      ['reconciliationDeptId', 'reconciliationDeptName'],
                      ['storageId', 'storageName']
                    )
                  "
                >
                  <el-option
                      v-for="(item, index) in storageOptions"
                      :key="index"
                      :label="item.storageName"
                      :value="item.storageId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="结算币种：" class="jy-form-input">
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.currency"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 4)"
                    :disabled="disabledTable"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.cnName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="应收合计：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.financeInAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="应付合计：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.financeOutAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="结算金额：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.settlementAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="对账单结算币种：" class="jy-form-input">
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.statementCurrency"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 4)"
                    @change="onSelectCurrency"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.cnName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="换算汇率：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.statementCurrencyExchange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="换算金额：" class="jy-form-input">
                <el-input
                    disabled
                    v-model="baseFormInfo.baseInfo.currencyAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="核准金额：" class="jy-form-input">
                <el-input
                    v-model="baseFormInfo.baseInfo.approvalAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="对账模板：" class="jy-form-input">
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.statementModeConfDictId"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="(item, index) in statementModeOptions"
                      :key="index"
                      :label="item.val"
                      :value="item.confDictId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="资金账号：" class="jy-form-input">
                <el-select
                    clearable
                    v-model="baseFormInfo.baseInfo.zjAccount"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 6)"
                >
                  <el-option
                      v-for="(item, index) in zjAccountOptions"
                      :key="index"
                      :label="item.zjAccountShow"
                      :value="item.zjAccount"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：" class="jy-form-input">
                <el-input
                    v-model="baseFormInfo.baseInfo.writeoffComment"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="账单明细">
        <div class="button-ground">
          <el-button
              v-if="!baseFormInfo.baseInfo.billInfosType || baseFormInfo.baseInfo.billInfosType.includes('finance_in')"
              plain
              class="jy-button"
              @click="onAddWaybill"
          >添加运单</el-button
          >
          <el-button
              v-if="baseFormInfo.baseInfo.billInfosType && baseFormInfo.baseInfo.billInfosType.includes('finance_record_group')"
              plain
              class="jy-button"
              @click="onAddFinanceRecordGroup"
          >添加运费单</el-button
          >
          <!-- <el-button plain class="jy-button">添加其他支出</el-button> -->
          <el-button plain class="jy-button" @click="onDelWaybill"
          >移除</el-button
          >
        </div>
        <div class="table-ground" style="margin-top: 20px">
          <el-table
              class="jy-common-table"
              header-align="center"
              border
              stripe
              :highlight-current-row="true"
              style="width: 100%"
              :data="financeTable"
              @selection-change="handleMxTableChange"
              show-summary
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column align="center" type="selection" width="55" />
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="createTime"
                label="业务日期"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeTypeShow"
                label="收支类型"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="documentStatusShow"
                label="单据类型"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="documentNumber"
                label="来源单据"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="categoryName"
                label="费项类型"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="serviceName"
                label="费项"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectStatus"
                label="结算对象类型"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectName"
                label="结算对象"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="currency"
                label="结算币种"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="noTaxTotalAmount"
                label="不含税总价"
            >
            </el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              align="center"
              prop="financeInAmount"
              label="应收金额"
            >
            </el-table-column> -->
            <!-- <el-table-column
              show-overflow-tooltip
              align="center"
              prop="financeOutAmount"
              label="应付金额"
            >
            </el-table-column> -->
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="settlementAmount"
                label="结算金额"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="writeoffComment"
                label="备注"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                align="center"
                prop="waybillCreateTime"
                label="创建日期"
            >
            </el-table-column>
          </el-table>
        </div>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="附件信息">
        <commonFuJian :data="annexTable" ref="domCommonFuJian"></commonFuJian>
      </AngleDouble>
    </div>
    <!-- 添加运单 -->
    <MessageBox
        :show="addWaybillVisible"
        inputType="input"
        formTitle="运单号"
        @onMessageBoxCancel="onCancelAddWaybill"
        @onMessageBoxConfirm="onConfirmAddWaybill"
    >
    </MessageBox>
    <!-- 添加运费单 -->
    <MessageBox
        :show="addFinanceRecordGroupVisible"
        inputType="input"
        formTitle="运费单单号"
        @onMessageBoxCancel="onCancelAddFinanceRecordGroup"
        @onMessageBoxConfirm="onConfirmAddFinanceRecordGroup"
    >
    </MessageBox>
  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import MessageBox from "@/components/messageBox/index.vue";
import utils from "@/assets/js/tool.js";
import commonFuJian from "@/components/fuJian/index.vue";
import AngleDouble from "@/components/details/angleDouble.vue";
import EnterpriseNoSetting from "@/assets/js/EnterpriseNoSetting.js";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'

export default {
  name: "ReceivableBillEdit",
  components: {
    MessageBox,
    commonFuJian,
    AngleDouble
  },
  data() {
    return {
      // 控件大小控制
      gutter: 12,
      span: 6,

      domCommonFuJian: null,
      annexTable: [],
      mainId: "",

      baseObj: {
        baseInfo: {
          approvalAmount: "",
          businessName: "",
          currency: "",
          currencyId: "",
          currencyAmount: "",
          financeInAmount: "",
          financeOutAmount: "",
          objectName: "",
          objectNumber: "",
          objectStatus: "",
          objectStatusConfDictId: "",
          reconciliationDeptId: "",
          reconciliationDeptName: "",
          settlementAmount: "",
          statementCurrencyId: "",
          statementCurrency: "",
          statementCurrencyExchange: "",
          statementId: "",
          statementMode: null,
          statementModeConfDictId: "",
          statementType: "pu_tong:statement_type",
          statementNumber: "",
          writeoffComment: "",
          zjAccount: "",
          billInfosType: [],
        },
      },

      financeTable: [],
      bfFinanceTable: [],
      baseFormInfo: {
        baseInfo: {
          approvalAmount: "",
          businessName: "",
          currency: "",
          currencyId: "",
          currencyAmount: "",
          financeInAmount: "",
          financeOutAmount: "",
          objectName: "",
          objectNumber: "",
          objectStatus: "",
          objectStatusConfDictId: "",
          reconciliationDeptId: "",
          reconciliationDeptName: "",
          settlementAmount: "",
          statementCurrencyId: "",
          statementCurrency: "",
          statementCurrencyExchange: "",
          statementId: "",
          statementMode: null,
          statementModeConfDictId: "",
          statementType: "pu_tong:statement_type",
          statementNumber: "",
          writeoffComment: "",
          zjAccount: "",
          billInfosType: [],
        },
      },
      bBaseFormInfo: {},
      disabledTable: true,

      objectStatusOptions: [],
      objectNameOptions: [],
      storageOptions: [],
      currencyOptions: [],
      statementModeOptions: [],
      zjAccountOptions: [],

      commonJumpKeys: EnterpriseNoSetting.keys,

      // 添加运单
      addWaybillVisible: false,
      mxTableSelect: [],
      delMXList: [],

      //运费单
      addFinanceRecordGroupVisible: false,

      submitObj: {
        approvalAmount: "",
        businessName: "",
        currency: "",
        currencyId: "",
        currencyAmount: "",
        financeInAmount: "",
        financeOutAmount: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        reconciliationDeptId: "",
        settlementAmount: "",
        statementCurrency: "",
        statementCurrencyId: "",
        statementCurrencyExchange: "",
        statementId: "",
        statementModeConfDictId: "",
        statementType: "pu_tong:statement_type",
        writeoffComment: "",
        zjAccount: "",
      },

      isOneOpen: true
    };
  },

  watch: {
    '$route': {
      handler: function(newValue, oldValue) {
        const query = newValue.query;
        const meta = newValue.meta;
        let clearStatus = sessionStorage.getItem(
            "clearReceivableManagementReceivableBillEdit"
        );
        if (meta.china == "应收对账单修改" && clearStatus == 1) {
          if (query && query.statementId) {
            this.mainId = query.statementId;
            this.financeTable = [];
            this.annexTable = [];
            this.delMXList = [];
            this.getDetailsData(query.statementId);
          }
        }
      },
      immediate: true
    },

    financeTable: {
      handler: function(newValue, oldValue) {
        console.log("明细变化", newValue);
        // 应收金额

        // let financeInAmount = parseFloat(baseFormInfo.baseInfo.settlementAmount);
        // let financeInAmount = parseFloat(baseFormInfo.baseInfo.financeInAmount);
        // 应付金额
        // let financeOutAmount = parseFloat(baseFormInfo.baseInfo.financeOutAmount);

        let financeInAmount = 0;
        let financeOutAmount = 0;
        newValue.forEach((item) => {
          // if (!isNaN(item.financeInAmount) && item.financeInAmount != "") {
          //   financeInAmount = financeInAmount + parseFloat(item.financeInAmount);
          // }
          if (!isNaN(item.settlementAmount) && item.settlementAmount != "") {
            financeInAmount =
                Number(financeInAmount || 0) + parseFloat(item.settlementAmount);
          }
          if (!isNaN(item.financeOutAmount) && item.financeOutAmount != "") {
            financeOutAmount =
                Number(financeOutAmount || 0) + parseFloat(item.financeOutAmount);
          }
        });

        this.baseFormInfo.baseInfo.financeInAmount = financeInAmount;
        this.baseFormInfo.baseInfo.financeOutAmount = financeOutAmount;
        this.baseFormInfo.baseInfo.settlementAmount = financeInAmount;
        // baseFormInfo.baseInfo.settlementAmount = financeInAmount - financeOutAmount;

        let num3 =
            parseFloat(this.baseFormInfo.baseInfo.statementCurrencyExchange || 0) *
            parseFloat(this.baseFormInfo.baseInfo.settlementAmount || 0);
        this.baseFormInfo.baseInfo.approvalAmount = num3.toFixed(
            this.commonJumpKeys.toFixedNum
        );
        this.baseFormInfo.baseInfo.currencyAmount = num3.toFixed(
            this.commonJumpKeys.toFixedNum
        );

        console.log(this.isOneOpen);
        if (this.isOneOpen) {
          this.isOneOpen = false;
          if (
              !isNaN(this.baseFormInfo.baseInfo.statementCurrencyExchange) &&
              this.baseFormInfo.baseInfo.statementCurrencyExchange != ""
          ) {
            this.baseFormInfo.baseInfo.approvalAmount =
                this.baseFormInfo.baseInfo.currencyAmount = (
                    parseFloat(this.baseFormInfo.baseInfo.statementCurrencyExchange || 0) *
                    parseFloat(this.baseFormInfo.baseInfo.settlementAmount || 0)
                ).toFixed(this.commonJumpKeys.toFixedNum);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted() {
    this.windowResize();
    window.onresize = () => {
      this.windowResize();
    };

    sessionStorage.setItem("clearReceivableManagementReceivableBillEdit", 1);
    this.bBaseFormInfo = utils.relObjRam(this.baseObj.baseInfo);
  },

  methods: {
    windowResize() {
      let clientWidth = document.body.clientWidth;
      if (clientWidth <= 1760) {
        this.span = 8;
      } else {
        this.span = 6;
      }
    },

    visibleChange(val, type) {
      if (val) {
        if (type == 1) {
          utils.getSelectData("object_status", 3).then((res) => {
            this.objectStatusOptions = res.arr;
          });
        } else if (type == 2) {
          utils.getSelectData("member_down_list", 9).then((res) => {
            this.objectNameOptions = res.arr;
          });
        } else if (type == 3) {
          // utils.getSelectData("storage_choose_list", 1).then((res) => {
          //   storageOptions.value = res.arr;
          // });
          if (this.commonJumpKeys.isAllDept) {
            // 所有部门/仓库/网点
            utils.getSelectData("dept_storage_choose_list", 1).then((res) => {
              this.storageOptions = res.arr;
            });
          } else {
            // 部门下拉列表
            utils.getSelectData("storage_choose_list", 1).then((res) => {
              this.storageOptions = res.arr;
            });
          }
        } else if (type == 4) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        } else if (type == 5) {
          utils.getSelectData("statement_mode", 3).then((res) => {
            this.statementModeOptions = res.arr;
          });
        } else if (type == 6) {
          utils.getSelectData("zj_account_down_list", 1).then((res) => {
            this.zjAccountOptions = res.arr;
          });
        }
      }
    },

    onPrint() {
      // 整柜/包柜模板
      if (this.baseFormInfo.baseInfo.statementModeConfDictId == 41) {
        // let obj = {
        //   "className": "print_data_zheng_gui_finance_in_statement",
        //   "id":mainId.value
        // }
        // router.push({ path: '/systemSettings/printSetting', query: obj })
        Api.getPrintModelList({
          modelType: "print_data_zheng_gui_finance_in_statement",
          isDefault: 1,
        }).then((res) => {
          const d = res.data.result.data || [];
          if (d.length > 0) {
            const obj = d[0];
            let hiprintTemplate = new hiprint.PrintTemplate({
              template: JSON.parse(obj.content),
            });
            let reqArr = [
              {
                conditonKey: "statementId",
                conditonVal: this.mainId,
              },
            ];
            Api.getPrintData({
              conditionReqs: reqArr,
              className: "print_data_zheng_gui_finance_in_statement",
            }).then((res) => {
              if (res.status == 200) {
                const data = res.data;
                if (data.status == "success") {
                  let result = data.result;
                  if (utils.jyCheckObjectType(result) == "Array") {
                    hiprintTemplate.print(result, {});
                  }
                }
              }
            });
          } else {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        });
      } else {
        Api.getPrintModelList({
          modelType: "print_data_sea_finance_in_statement",
          isDefault: 1,
        }).then((res) => {
          const d = res.data.result.data || [];
          if (d.length > 0) {
            if (d.length > 0) {
              const obj = d[0];
              let hiprintTemplate = new hiprint.PrintTemplate({
                template: JSON.parse(obj.content),
              });
              let reqArr = [
                {
                  conditonKey: "statementId",
                  conditonVal: this.mainId,
                },
              ];
              Api.getPrintData({
                conditionReqs: reqArr,
                className: "print_data_sea_finance_in_statement",
              }).then((res) => {
                if (res.status == 200) {
                  const data = res.data;
                  if (data.status == "success") {
                    let result = data.result;
                    if (utils.jyCheckObjectType(result) == "Array") {
                      hiprintTemplate.print(result, {});
                    }
                  }
                }
              });
            } else {
              ElMessage({
                message: "打印模板不存在",
                type: "error",
              });
            }
          } else {
            ElMessage({
              message: "打印模板不存在",
              type: "error",
            });
          }
        });
      }
    },

    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.baseFormInfo[type[1]] = obj[select[1]];
        }
      }
      this.baseFormInfo[type[0]] = val;
    },

    onSelectCurrency(val) {
      let arr = this.currencyOptions.filter((value, index) => {
        return value.cnName == val;
      });
      if (arr && arr.length > 0) {
        let obj = arr[0];
        this.baseFormInfo.baseInfo.statementCurrency = obj.cnName;
        this.baseFormInfo.baseInfo.statementCurrencyId = obj.currencyId;

        // baseFormInfo.baseInfo.statementCurrencyExchange = obj.exchangeRate;
        // if (!isNaN(obj.exchangeRate) && obj.exchangeRate != "") {
        //   baseFormInfo.baseInfo.currencyAmount =
        //     parseFloat(obj.exchangeRate) * baseFormInfo.baseInfo.settlementAmount;
        //   baseFormInfo.baseInfo.approvalAmount =
        //     baseFormInfo.baseInfo.currencyAmount;
        // }
        // 获取汇率
        let param = {
          destCurrencyAbbrName: "",
          destCurrencyId: this.baseFormInfo.baseInfo.statementCurrencyId || "", //目标币种
          originalCurrencyAbbrName: "",
          originalCurrencyId: this.baseFormInfo.baseInfo.currencyId || "", //原来币种
        };
        Api.getRateValue(param)
            .then((res) => {
              // baseFormInfo.baseInfo.statementCurrencyExchange
              this.baseFormInfo.baseInfo.statementCurrencyExchange =
                  parseFloat(res.data.result || 0) || 1;
              this.baseFormInfo.baseInfo.currencyAmount = (
                  this.baseFormInfo.baseInfo.statementCurrencyExchange *
                  parseFloat(this.baseFormInfo.baseInfo.settlementAmount)
              ).toFixed(this.commonJumpKeys.toFixedNum);
              this.baseFormInfo.baseInfo.approvalAmount =
                  parseFloat(this.baseFormInfo.baseInfo.currencyAmount || 0) * 1;
            })
            .catch(() => {
              this.baseFormInfo.baseInfo.statementCurrencyExchange = "0.00";
              this.baseFormInfo.baseInfo.currencyAmount = "0.00";
              this.baseFormInfo.baseInfo.approvalAmount = "0.00";
            });
      }
    },

    onSelectObjectName(val) {
      let arr = this.objectNameOptions.filter((value, index) => {
        return value.memberId == val;
      });
      if (arr && arr.length > 0) {
        let obj = arr[0];
        this.baseFormInfo.baseInfo.objectName = obj.userMemberName;
      }
    },

    onAddWaybill() {
      this.addWaybillVisible = true;
    },

    onDelWaybill() {
      if (this.mxTableSelect.length > 0) {
        this.$confirm("是否删除选定数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              this.mxTableSelect.forEach((value, key) => {
                this.financeTable.forEach((item, index) => {
                  if (value.financeId == item.financeId) {
                    if (item.operationType !== "ADD") {
                      let objs = JSON.parse(JSON.stringify(item));
                      objs.operationType = "DEL";
                      this.delMXList.push(objs);
                    }
                    this.financeTable.splice(index, 1);
                  }
                });
              });
            })
            .catch(() => {});
      } else {
        ElMessage({
          message: "请选择明细表格数据",
          type: "warning",
        });
      }
    },

    // 装载明细表格数据选中
    handleMxTableChange(val) {
      this.mxTableSelect = val;
    },

    onCancelAddWaybill() {
      this.addWaybillVisible = false;
    },

    // 输出运单
    onConfirmAddWaybill(msg) {
      if (msg) {
        for (let i = 0; i < this.financeTable.length; i++) {
          if (this.financeTable[i].documentNumber == msg) {
            ElMessage({
              message: "运单号已存在！",
              type: "warning",
            });
            return;
          }
        }
        let obj1 = {
          waybillNumber: msg,
        };
        const obj2 = {
          pageStart: 1,
          pageTotal: 1,
          pageCount: 1,
          papeStart: 1,
          isCustomes: 0,
        };
        const obj3 = Object.assign({}, obj1, obj2);
        Api.getWaybillList(obj3).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              let result = data.result;
              let tableArr = result.data;
              if (utils.jyCheckObjectType(tableArr) == "Array") {
                let has = false;
                if (tableArr.length > 0) {
                  for (let i = 0; i < tableArr.length; i++) {
                    const element = tableArr[i];
                    if (this.baseFormInfo.baseInfo.objectName) {
                      if (
                          element.userMemberName != this.baseFormInfo.baseInfo.objectName
                      ) {
                        ElMessage({
                          message: "客户名称不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectName = element.userMemberName;
                    }
                    if (this.baseFormInfo.baseInfo.objectNumber) {
                      if (element.memberId != this.baseFormInfo.baseInfo.objectNumber) {
                        ElMessage({
                          message: "客户代码不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectNumber = element.memberId;
                    }
                    if (!element.currency) {
                      ElMessage({
                        message: "结算币种不存在！",
                        type: "error",
                      });
                      return;
                    }
                    if (this.baseFormInfo.baseInfo.currency) {
                      if (element.currency != this.baseFormInfo.baseInfo.currency) {
                        ElMessage({
                          message: "币种不一致！",
                          type: "error",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.currency = element.currency;
                    }
                    if (!element.financeId) {
                      ElMessage({
                        message: "运单未审核！",
                        type: "error",
                      });
                      return;
                    }
                    let obj = {
                      financeId: element.financeId,
                      financeType: "finance_in",
                      operationType: "ADD",
                      createTime: element.businessDate,
                      financeTypeShow: "应收",
                      documentStatus: "",
                      documentStatusShow: "tms运单单据",
                      documentNumber: element.waybillNumber,
                      categoryName: "",
                      serviceName: "",
                      objectStatus: "", //会员
                      objectStatusConfDictId: "", //3
                      objectName: element.userMemberName,
                      currency: element.currency,
                      noTaxTotalAmount: element.noTaxTotalAmount,
                      financeInAmount: element.totalFreight || 0,
                      settlementAmount: element.totalFreight || 0,
                      financeOutAmount: 0,
                      writeoffCcomment: "",
                      waybillCreateTime: "",
                    };
                    this.financeTable.push(obj);
                  }
                }
              }
            }
          }
        });
        this.addWaybillVisible = false;
      }
    },

    onAddFinanceRecordGroup() {
      this.addFinanceRecordGroupVisible = true;
    },

    onCancelAddFinanceRecordGroup() {
      this.addFinanceRecordGroupVisible = false;
    },

    onConfirmAddFinanceRecordGroup(msg) {
      if (msg) {
        for (let i = 0; i < this.financeTable.length; i++) {
          if (this.financeTable[i].documentNumber == msg) {
            ElMessage({
              message: "运费单单号已存在！",
              type: "warning",
            });
            return;
          }
        }
        let qArr = [];
        let obj = {
          conditonKey: "frgNumberNotLike",
          conditonVal: msg,
        };
        qArr.push(obj);
        Api.runPageReport({
          conditionReqs: qArr,
          number: "admin_finance_in_waybill_item_service_group_list",
          pageStart: 1,
          pageTotal: 100,
        }).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              let result = data.result;
              const rdatas = result.datas;
              let tableArr = rdatas.data;
              if (utils.jyCheckObjectType(tableArr) == "Array") {

                let has = false;
                if (tableArr.length > 0) {
                  for (let i = 0; i < tableArr.length; i++) {
                    const element = tableArr[i];

                    for (let i = 0; i < this.financeTable.length; i++) {
                      if (
                          this.financeTable[i].documentNumber ==
                          element.financeNumber
                      ) {
                        ElMessage({
                          message: "运费单单号已存在！",
                          type: "warning",
                        });
                        return false;
                      }
                    }

                    if (this.baseFormInfo.baseInfo.objectName) {
                      if (
                          element.objectName != this.baseFormInfo.baseInfo.objectName
                      ) {
                        ElMessage({
                          message: "结算对象不一致！",
                          type: "warning",
                        });
                        return;
                      }
                    } else {
                      this.baseFormInfo.baseInfo.objectName = element.objectName;
                    }
                    // if (baseFormInfo.baseInfo.objectNumber) {
                    //   if (element.objectNumber != baseFormInfo.baseInfo.objectNumber) {
                    //     ElMessage({
                    //       message: "结算对象不一致！",
                    //       type: "error",
                    //     });
                    //     return;
                    //   }
                    // } else {
                    //   baseFormInfo.baseInfo.objectNumber = element.memberId;
                    // }
                    this.baseFormInfo.baseInfo.objectNumber = element.objectNumber;
                    if (!element.currency) {
                      ElMessage({
                        message: "结算币种不存在！",
                        type: "error",
                      });
                      return;
                    }
                    if (this.baseFormInfo.baseInfo.currency) {
                      if (element.currency != this.baseFormInfo.baseInfo.currency) {
                        ElMessage({
                          message: "币种不一致！",
                          type: "error",
                        });
                        return;
                      }
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId + "";
                    } else {
                      this.baseFormInfo.baseInfo.currency = element.currency;
                      this.baseFormInfo.baseInfo.currencyId = element.currencyId + "";
                    }
                    if (!element.financeId) {
                      ElMessage({
                        message: "运费单有误,请重新添加！",
                        type: "error",
                      });
                      return;
                    }
                    let obj = {
                      financeId: element.financeId,
                      financeType: "finance_record_group",
                      operationType: "ADD",
                      createTime: element.businessDate,
                      financeTypeShow: "应收",
                      documentStatus: "",
                      documentStatusShow: "运费单",
                      documentNumber: element.financeNumber,
                      categoryName: "",
                      serviceName: "",
                      objectStatus: element.objectStatus,
                      objectName: element.objectName,
                      currency: element.currency,
                      currencyId: element.currencyId || "",
                      financeInAmount: element.totalFreight || 0,
                      noTaxTotalAmount: element.totalFreight || 0,
                      financeOutAmount: 0,
                      writeoffCcomment: "",
                      waybillCreateTime: "",
                    };
                    this.financeTable.push(obj);
                  }
                }else{
                  ElMessage({
                    message: "查不到数据！",
                    type: "error",
                  });
                  return;
                }
              }else{
                ElMessage({
                  message: "查不到数据！",
                  type: "error",
                });
                return;
              }
            }
          }
          this.addFinanceRecordGroupVisible = false;
        });
      }
    },

    onSave() {
      // let arr = [];
      // fileNameLists.value.forEach((item) => {
      //   if (item.status == "success") {
      //     arr.push({
      //       "fileId": item.name,
      //       "fileName": item.name
      //     });
      //   }
      // });
      let submitData = utils.oldObjToNewObj(this.submitObj, this.baseFormInfo.baseInfo);
      let documentBills = [];
      let arrA = this.bfFinanceTable || []; //备份
      let arrB = this.financeTable || []; // 提交
      // attr是用于区分的属性
      // arr1是提交的数据
      // arr2是备份的数据（数据初始化的时候的详情）
      let fArr = utils.jyTransformDataStatus("financeId", arrB, arrA);
      console.log("arrA", arrA);
      console.log("arrB", arrB);
      console.log("fArr", fArr);
      fArr.forEach((element) => {
        let obj = {
          financeId: element.financeId,
          financeType: element.financeType,
          operationType: element.operationType,
        };
        documentBills.push(obj);
      });
      let newDCList = [...documentBills, ...this.delMXList];

      let files = this.$refs.domCommonFuJian.annexTable || [];
      let DELFilesList = this.$refs.domCommonFuJian.DELFilesList || [];
      let pFiles = [...files, ...DELFilesList];

      let params = Object.assign(
          { baseInfo: submitData },
          { documentBills: newDCList },
          { fileList: pFiles }
      );
      Api.updateStatement(params).then((res) => {
        if (res.status == 200) {
          this.delMXList = [];
          const data = res.data;
          if (utils.jyCheckObjectType(data) == "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
      this.getDetailsData(this.baseFormInfo.baseInfo.statementId);
    },

    onButtonFun(type) {
      if (type == 1) {
        let params = {
          statementIds: [this.mainId],
        };
        Api.approveryStatement(params).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) == "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
            }
          }
        });
      } else if (type == 2) {
        let params = {
          statementIds: [this.mainId],
        };
        Api.reapproveryStatement(params).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) == "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
            }
          }
        });
      } else if (type == 3) {
        let params = {
          statementIds: [this.mainId],
        };
        Api.pushStatement(params).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) == "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
            }
          }
        });
      } else if (type == 4) {
        let params = {
          statementIds: [this.mainId],
        };
        Api.customerStatement(params).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) == "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
            }
          }
        });
      } else if (type == 5) {
        this.$confirm("是否对该单进行取消对账？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let params = {
            statementIds: [this.mainId],
          };
          Api.cancelCustomerStatement(params).then((res) => {
            if (res.status == 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) == "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
              }
            }
          });
        });
      } else if (type == 6) {
        this.$confirm("确认删除吗？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let params = {
            statementIds: [this.mainId],
          };
          Api.delStatement(params).then((res) => {
            if (res.status == 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) == "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                bus.emit("busDelMenu");
                this.$router.push({ path: "/receivableManagement/receivableBillList" });
              }
            }
          });
        });
      }
    },

    // 查询详情页数据  -- begin
    getDetailsData(id) {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中...", //可以自定义文字
        background: "rgba(255, 255, 255, 0)", //遮罩层背景色
      });
      let params1 = {
        statementId: id,
      };
      let arr = [];
      Api.getStatementDetail(params1).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          this.baseFormInfo.baseInfo.billInfosType = ["finance_in"];
          if (data.status == "success") {
            let result = data.result;
            if (utils.jyCheckObjectType(result) == "Object") {
              utils.oldObjToNewObj(this.baseFormInfo.baseInfo, result.baseInfo);

              this.baseFormInfo.baseInfo.approvalAmount = parseFloat(
                  this.baseFormInfo.baseInfo.approvalAmount || 0
              ).toFixed(this.commonJumpKeys.toFixedNum);

              if (this.baseFormInfo.baseInfo.statementModeConfDictId) {
                this.baseFormInfo.baseInfo.statementModeConfDictId = String(
                    this.baseFormInfo.baseInfo.statementModeConfDictId
                );
              }

              const documentBills = result.documentBills;
              if (utils.jyCheckObjectType(documentBills) == "Array") {
                documentBills.forEach((item) => {
                  item.operationType = "UPDATE";
                });
                this.financeTable = documentBills;
                this.baseFormInfo.baseInfo.billInfosType = [documentBills[0].financeType];
                console.log("AfinanceTable.value", this.financeTable);
                // bfFinanceTable.value = utils.relObjRam(documentBills);
                this.bfFinanceTable = JSON.parse(JSON.stringify(documentBills)); //备份
              }
              if (result.fileList) {
                if (utils.jyCheckObjectType(result.fileList) == "Array") {
                  if (result.fileList.length > 0) {
                    result.fileList.forEach((item) => {
                      arr.push({
                        fileName: item.fileName,
                        fileId: item.fileId,
                        fileType: item.fileType ? item.fileType : "",
                        createTime: item.createTime ? item.createTime : "",
                        operationUserName: item.operationUserName
                            ? item.operationUserName
                            : "",
                        operationType: "UPDATE",
                      });
                    });
                  }
                  this.annexTable = arr;
                }
              } else {
                this.annexTable = [];
              }

              if (
                  this.baseFormInfo.baseInfo.statementCurrencyId &&
                  this.baseFormInfo.baseInfo.currencyId
              ) {
                // 获取汇率
                let param = {
                  destCurrencyAbbrName: "",
                  destCurrencyId: this.baseFormInfo.baseInfo.statementCurrencyId || "", //目标币种
                  originalCurrencyAbbrName: "",
                  originalCurrencyId: this.baseFormInfo.baseInfo.currencyId || "", //原来币种
                };
                Api.getRateValue(param)
                    .then((res) => {
                      // baseFormInfo.baseInfo.statementCurrencyExchange
                      this.baseFormInfo.baseInfo.statementCurrencyExchange =
                          parseFloat(res.data.result || 0) || 1;
                      this.baseFormInfo.baseInfo.currencyAmount = (
                          parseFloat(
                              this.baseFormInfo.baseInfo.statementCurrencyExchange || 0
                          ) * parseFloat(this.baseFormInfo.baseInfo.settlementAmount || 0)
                      ).toFixed(this.commonJumpKeys.toFixedNum);
                    })
                    .catch(() => {
                      this.baseFormInfo.baseInfo.statementCurrencyExchange = "0.00";
                      this.baseFormInfo.baseInfo.currencyAmount = "0.00";
                      // baseFormInfo.baseInfo.approvalAmount = "0.00";
                    });
              }
            }
          }
        }
      });
      utils.getSelectData("statement_mode", 3).then((res) => {
        this.statementModeOptions = res.arr;
      });
      loading.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.jy-form-container {
  padding: 20px;
  padding-bottom: 100px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}
</style>
